import React, { Component } from "react";
import {
  Box,
  Button,
  Backdrop,
  Typography,
  CircularProgress,
  TextField,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import * as Yup from "yup";
import { Formik } from "formik";
import { Link } from "react-router-dom";
import agent from "../../agent/agent";
import { showError, showSuccess } from "../../utils/notifications";
import Logo from "../../icons/Logo";

const initValues = {
  email: ''
}
const validationSchema = Yup.object().shape({
  email: Yup.string().email('Некорректно заполнен Email').required('Обязательно к заполнению'),
});

class PasswordReset extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isBackdrop: false
    };
  }

  onPasswordReset = async (body) => {
    await this.setState({ isBackdrop: true });

    const resPasswordReset = await agent.post('/auth/password-reset', body)
      .then((res) => res.data).catch((err) => {
        return { error: err.response?.data?.details || 'Ошибка сервера, повторите попытку позднее.' }
      });
    if (resPasswordReset?.error) {
      await this.setState({ isBackdrop: false });
      showError('Ошибка сброса пароля', resPasswordReset?.error);
      return
    }

    await this.setState({ isBackdrop: false });
    showSuccess('Запрос отправлен', 'Если пользователь с таким Email зарегистрирован, на него выслана инструкция по восстановлению пароля');
  }

  render() {
    const { isBackdrop } = this.state;
    const { classes } = this.props;
    return (
      <div className={classes.page}>
        <div className={classes.card}>
          <div className={classes.logoWrap}>
            <Logo sx={{ fontSize: 40, width: 40, height: 29 }} />
            <div className={classes.logoText}>
              <span className={classes.logoTitle}>ЦИФРОВОЙ ПУТЬ</span>
              <span className={classes.logoSubtitle}>Подсистема Пользователи</span>
            </div>
          </div>

          <Typography className={classes.heading}>Сброс пароля</Typography>

          <Formik
            initialValues={initValues}
            validationSchema={validationSchema}
            onSubmit={this.onPasswordReset}
          >{(props) => {
            const { values, errors, touched, handleSubmit, handleChange } = props;
            return (
              <div className={classes.form}>
                <TextField
                  value={values.email}
                  label="Email"
                  name="email"
                  variant="outlined"
                  fullWidth
                  helperText={touched.email && errors.email}
                  error={Boolean(touched.email && errors.email)}
                  onChange={handleChange}
                />
                <Button
                  fullWidth
                  variant="contained"
                  onClick={handleSubmit}
                  className={classes.submitBtn}
                >
                  Отправить запрос
                </Button>
                <Box display="flex" justifyContent="center">
                  <Button
                    component={Link}
                    variant="text"
                    size="small"
                    to="/"
                    className={classes.linkBtn}
                  >
                    Вернуться к авторизации
                  </Button>
                </Box>
              </div>
            )
          }}</Formik>
        </div>

        <Backdrop open={isBackdrop}>
          <CircularProgress />
        </Backdrop>
      </div>
    );
  }
}

const useStyles = makeStyles(() => ({
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#F4F4F5",
  },
  card: {
    width: "100%",
    maxWidth: 420,
    background: "#fff",
    borderRadius: 8,
    border: "1px solid #E4E4E7",
    padding: "40px 36px",
  },
  logoWrap: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 10,
    marginBottom: 32,
  },
  logoText: {
    display: "flex",
    flexDirection: "column",
  },
  logoTitle: {
    fontSize: 15,
    fontWeight: 700,
    lineHeight: "18px",
    color: "#27272A",
    letterSpacing: "0.02em",
  },
  logoSubtitle: {
    fontSize: 11,
    fontWeight: 400,
    lineHeight: "14px",
    color: "#71717A",
  },
  heading: {
    fontSize: 20,
    fontWeight: 600,
    color: "#27272A",
    textAlign: "center",
    marginBottom: 24,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
  },
  submitBtn: {
    height: 44,
    fontSize: 15,
    fontWeight: 600,
    marginTop: 4,
  },
  linkBtn: {
    textTransform: "none",
    fontWeight: 400,
    fontSize: 14,
    color: "#71717A",
    "&:hover": {
      color: "#4F39F6",
      backgroundColor: "transparent",
    },
  },
}));

const StyledPasswordReset = (props) => {
  const classes = useStyles();
  return <PasswordReset {...props} classes={classes} />;
};

export default StyledPasswordReset
